<template>
	<div id="notFound">

		<img :src="logo" alt="Boleto Web" class="center-block logo"><br>
		<div class="text-center col-sm-12">
			<h1>Ops! Você se perdeu! </h1>
			<h4>Esta página não existe.</h4>
			<router-link to="/" class="vertical-5p lead">Voltar para o início.</router-link>
		</div>
	</div>
</template>
<script>
export default {
	name: 'NotFound',
	data (router) {
		return {
			logo: `${this.$store.state.serverURI}/images/logo-premium.png`,
		}
	},
}
</script>

<style>
#notFound {
  padding: 10em;
  color: white;
}
</style>



// WEBPACK FOOTER //
// 404.vue?9cc869d6